import React, { useState } from "react"
import { Panel } from "./index"
import { BaseSelect } from "components/atoms/input/select"
import { CHART_RANGE, CHART_TYPE } from "config/const"
import { MiniChartComponent } from "components/molecules/chart/miniChart"
import { checkIsSp, getCountryIcon } from "utils/util"
import { map, get } from "lodash"
import ClassNames from "classnames"

type Props = {
  delete?: Function
}
const stubSymbol = [
  {
    id: 0,
    name: "マイクロソフト",
  },
]

export const ChartPanel = (props: Props) => {
  return (
    <Panel
      title="チャート"
      delete={props.delete}
      filter={<BaseSelect option={stubSymbol} />}
    >
      <div className="list-block">
        <div className="row-filter">
          <BaseSelect option={CHART_TYPE} />
          <BaseSelect option={CHART_RANGE} />
        </div>
        <div className="chart-list-contents chart-control-row">
          <div className="chart-content" />
        </div>
      </div>
    </Panel>
  )
}

export const SummaryChart = (props: { dataList?: Array<object> }) => {
  const isPhone = checkIsSp()
  const [filterId, setFilterId] = useState(0)
  const chartList = map(props.dataList, (data: object, i: number) => {
    const icon = getCountryIcon(data)
    return {
      id: i,
      name: get(data, "SymbolName"),
      icon: ClassNames("icon-solid ", icon),
    }
  })

  return (
    <Panel title="" className="panel-summary-chart" nonePanelHeader={true}>
      <ul className="chart-list-contents chart-list">
        {!isPhone ? (
          <>
            <MiniChartComponent
              key={0}
              data={{
                Exchange: 1,
                SecurityType: 0,
                Symbol: "101",
                SymbolName: "日経平均",
                NumberOfDecimals: 2,
              }}
              hasIcon={true}
            />
            <MiniChartComponent
              key={1}
              data={{
                Exchange: 1,
                SecurityType: 0,
                Symbol: "151",
                SymbolName: "TOPIX",
                NumberOfDecimals: 2,
              }}
              hasIcon={true}
            />
          </>
        ) : (
          <MiniChartComponent
            key={1}
            data={{
              Exchange: 1,
              SecurityType: 0,
              Symbol: "101",
              SymbolName: "日経平均",
              NumberOfDecimals: 2,
            }}
            dataList={props.dataList}
            selectOption={chartList}
            listNum={filterId}
            changeList={setFilterId}
          />
        )}
      </ul>
    </Panel>
  )
}
